import React, { useContext, useState } from "react";
import { Form } from "react-router-dom";
import AdminContext from "../../../StateContext/Application";
function CreateAuction() {
  const data = useContext(AdminContext);
  const { CreateAuction } = data;
  // Define the state variable to hold the form data as a JSON object
  const [formData, setFormData] = useState({
    Tender_Name: "",
    PO_Number: Date.now().toFixed(),
    Description: "",
    GST: "",
    Tender_Opening_Date: "",
    Tender_Closing_Date: "",
    ErnestMoneyDeposit: "",
    TenderFee: "",
    Contact_Information: ""
  });

  var upload = new FormData();

  const handleSubmit = async (e) => {
    e.preventDefault();
      try {
        for (const key in formData) {
          upload.append(key, formData[key]);
        }

        let Auction_Supporting_Docs = document.getElementById("Tender_Supporting_Docs").files;
        upload.append("AuctionDocs", Auction_Supporting_Docs[0]);
        let Auction_Picture = document.getElementById("Tender_Picture").files;
        upload.append("AuctionDocs", Auction_Picture[0]);
        console.log("upload",upload);
        
        let data = await CreateAuction(upload);

        if (data === true) {
          alert("We have Successfully Created Scheme");
          window.location.href = "/AdminDashboard/EditAuction";
        } else {
          alert('Token Not Validated Through Esignature')
          window.location.reload()
        }
      } catch (error) {
        console.error(error);
      }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    if (id === "Tender_Name") {
      // Regular expression to allow only letters, numbers, and spaces
      const validName = /^[a-zA-Z0-9 ]*$/;

      if (!validName.test(value)) {
        alert("Scheme Name cannot contain special characters.");
        return;
      }
    }
    setFormData({
      ...formData,
      [id]: value,
    });
  };



  return (
    <div className="container my-5">
      <div className="card p-4">
        <h2 className="card-title text-center">Scheme Form</h2>
        <Form onSubmit={handleSubmit}>
          <div className="row mb-3">
            <div className="col">
              <label htmlFor="Tender_Name" className="form-label">
                Scheme Name
              </label>
              <input
                type="text"
                className="form-control"
                required
                onChange={(e) => handleInputChange(e)}
                id="Tender_Name"
                placeholder="Enter Scheme Name Here"
              />
            </div>
            <div className="col" hidden>
              <label htmlFor="PO_Number" className="form-label">
                PO Number
              </label>
              <input
                type="text"
                className="form-control"
                value={Date.now().toFixed()}
                required
                onChange={(e) => handleInputChange(e)}
                id="PO_Number"
                placeholder="Enter PO Number Here"
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col">
              <label htmlFor="Description" className="form-label">
                Description
              </label>
              <textarea
                className="form-control"
                required
                onChange={(e) => handleInputChange(e)}
                id="Description"
                rows="3"
                placeholder="Enter Scheme Description Here"
              ></textarea>
            </div>
          </div>

          <div className="row mb-3">
            <div className="col">
              <label htmlFor="Tender_Opening_Date" className="form-label">
              Scheme Opening Date
              </label>
              <input
                type="datetime-local"
                className="form-control"
                required
                onChange={(e) => handleInputChange(e)}
                id="Tender_Opening_Date"
              />
            </div>
            <div className="col">
              <label htmlFor="Tender_Closing_Date" className="form-label">
              Scheme Closing Date
              </label>
              <input
                type="datetime-local"
                className="form-control"
                required
                onChange={(e) => handleInputChange(e)}
                id="Tender_Closing_Date"
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col">
              <label htmlFor="ErnestMoneyDeposit" className="form-label">
                Ernest Money Deposit
              </label>
              <input
                type="number"
                className="form-control"
                required
                onChange={(e) => handleInputChange(e)}
                id="ErnestMoneyDeposit"
                placeholder="Enter Ernest Money Deposit Here"
              />
            </div>
            <div className="col">
              <label htmlFor="TenderFee" className="form-label">
              Scheme Fee
              </label>
              <input
                type="number"
                className="form-control"
                required
                onChange={(e) => handleInputChange(e)}
                id="TenderFee"
                placeholder="Enter Scheme Fee Here"
              />
            </div>
          </div>

          <div className="row mb-3">
            <div className="col">
              <label htmlFor="Contact_Information" className="form-label">
                Contact Information
              </label>
              <input
                type="number"
                minLength={10}
                maxLength={10}
                className="form-control"
                required
                onChange={(e) => handleInputChange(e)}
                id="Contact_Information"
                placeholder="Enter Contact Here"
              />
            </div>
            <div className="col">
              <label htmlFor="GST" className="form-label">
                GST
              </label>
              <input
                type="number"
                className="form-control"
                required
                onChange={(e) => handleInputChange(e)}
                id="GST"
                placeholder="Enter GST Here"
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col">
              <label htmlFor="tenderType" className="form-label">
              Scheme Picture
              </label>
              <input type="file" className="form-control" id="Tender_Picture" />
            </div>
            <div className="col">
              <label htmlFor="Tender_Supporting_Docs" className="form-label">
              Scheme Supporting Docs
              </label>
              <input
                type="file"
                className="form-control"
                id="Tender_Supporting_Docs"
              />
            </div>
          </div>
          <div className="text-center"></div>
            <button
            type="submit"
            className="btn btn-success form-control"
           >
            Submit
          </button>
        </Form>

      </div>
    </div>
  );
}

export default CreateAuction;
